import React, { useRef } from "react";

/* Arrow keys move focus only; Enter/Space selects, because selecting saves to
   the server and must not fire on every arrow press. */
const AccountSettingSegmented = ({
  options,
  value,
  onChange,
  disabled,
  ariaLabel,
}) => {
  const buttonRefs = useRef([]);

  /* Roving tab stop: the selected option, or the first when none matches. */
  let tabStopIndex = 0;
  options.forEach((option, index) => {
    if (option.value === value) {
      tabStopIndex = index;
    }
  });

  const handleSelect = (optionValue) => {
    if (disabled || optionValue === value) {
      return;
    }
    onChange(optionValue);
  };

  const handleKeyDown = (event, index) => {
    let nextIndex = null;
    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
      nextIndex = (index + 1) % options.length;
    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
      nextIndex = (index - 1 + options.length) % options.length;
    }
    if (nextIndex === null) {
      return;
    }
    event.preventDefault();
    const nextButton = buttonRefs.current[nextIndex];
    if (nextButton) {
      nextButton.focus();
    }
  };

  return (
    <div className="bwai-as-segmented" role="radiogroup" aria-label={ariaLabel}>
      {options.map((option, index) => (
        <button
          key={option.value}
          ref={(node) => {
            buttonRefs.current[index] = node;
          }}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          tabIndex={index === tabStopIndex ? 0 : -1}
          className="bwai-as-segmented-btn"
          disabled={disabled}
          onClick={() => handleSelect(option.value)}
          onKeyDown={(event) => handleKeyDown(event, index)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default AccountSettingSegmented;
